import styled, { css } from 'styled-components';
import Image from 'next/image';

import { devices, applyEllipsisByNumOfLines } from '@/UI/Styles';

const applyMargin = css`
  margin-bottom: 8px;
  @media ${devices['no-mobile']} {
    margin-bottom: 24px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 525px;
  cursor: pointer;

  & .card {
    height: 100%;
    padding: 0;
    text-align: justify;
    color: ${({ theme }) => theme.palette.grays80};
    border: solid 1px rgba(26, 26, 26, 0.5);
    border-radius: 16px;
    cursor: pointer;
    transition: 200ms ease-in-out;
    min-height: 200px;
    @media ${devices['no-mobile']} {
      min-height: 255px;
    }

    &:hover {
      border: ${({ theme }) => `solid 1px ${theme.brandTheme.brand50}`};
      box-shadow: ${({ theme }) => `4px 4px 4px 0px ${theme.brandTheme.brand20}`};
    }
  }

  & .title {
    text-transform: capitalize;
    color: ${({ theme }) => theme.palette.grays80};
    ${applyEllipsisByNumOfLines()}
    ${applyMargin}
  }

  & .description {
    color: ${({ theme }) => theme.palette.grays50};
    ${applyMargin}
  }

  & .description {
    ${applyMargin}
  }

  & .dameTimeContainer {
    display: flex;
    justify-content: space-between;
    text-transform: capitalize;
  }
  & .localClosed {
    color: ${({ theme }) => theme.palette.grays50};
  }
`;
export const Content = styled.div`
  height: auto;
  padding: 16px;
  p {
    font-size: 14px;
  }
  .title {
    color: ${({ theme }) => theme.palette.grey400};
    opacity: 80%;
  }
  @media ${devices['no-mobile']} {
    padding: 16px;
  }
`;

export const LocalImgContainer = styled.div`
  position: relative;
  height: 200px !important;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: ${({ theme }) => `${theme.spacing[16]} ${theme.spacing[16]} 0 0`};

  @media ${devices['no-mobile']} {
    height: 140px !important;
  }
  @media ${devices.Medium} {
    height: 190px !important;
  }
  @media ${devices.Large} {
    height: 280px !important;
  }
  span {
    width: 100%;
    height: 100% !important;
  }
`;

export const LocalImg = styled(Image)`
  border-radius: 16px 16px 0 0;
  margin: 0 !important;
  height: 100% !important;
  max-height: unset !important;
  width: 100% !important;
  position: absolute !important;
  top: 0;
  left: 0;
  object-fit: cover;
`;

export const BannerGradient = styled.div`
  background: ${({ theme }) => `linear-gradient(50deg, ${theme.brandTheme.brand50} 0%, #fff 100%)`};
  border-radius: 16px 16px 0 0;

  margin: 0;
  height: auto;
  width: 100%;
  position: relative;
  min-height: 185px;
  height: 200px !important;
  @media ${devices['no-mobile']} {
    height: 140px !important;
  }
  @media ${devices.Medium} {
    height: 190px !important;
  }
  @media ${devices.Large} {
    height: 280px !important;
  }
`;
